const Flickity = require('flickity');
import GLightbox from 'glightbox';

export default () => {

    const sliders = document.querySelectorAll('[data-image-slider]');
    if (sliders.length) {
        for (const slider of sliders) {

            const dom = slider.querySelector('[data-slider]');
            const next = slider.querySelector('[data-next]');
            const prev = slider.querySelector('[data-prev]');
            const zoom = slider.querySelector('[data-zoom]');

            const id = slider.getAttribute('data-image-slider');
            const slides = parseInt(dom.getAttribute('data-slides'));

            const f = new Flickity(dom, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                // autoPlay: 5000,
            });

            next.addEventListener('click', (e) => {
                e.preventDefault();
                f.next();
            });

            prev.addEventListener('click', (e) => {
                e.preventDefault();
                f.previous();
            });

            f.on('change', (index) => {
                if (index === 0) {
                    prev.classList.add('last');
                } else {
                    prev.classList.remove('last');
                }


                console.log(index, slides);

                if (index + 1 === slides) {
                    next.classList.add('last');
                } else {
                    next.classList.remove('last');
                }
            })

            const gLightbox = GLightbox({
                selector: '[data-element="' + id +'"]'
            });

            zoom.addEventListener('click', (e) => {
                e.preventDefault();
                gLightbox.open();
            })

        }
    }

}
